import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const SystemPrivate = RepositoryFactory.get('systemPrivate')

const state = {
  canAddQuestionByMatrix: false,
  canAddQuestionFromBank: false,
  allowCrossVendorInvoke: false,
  canAddQuestionFromQS: false,
}
const actions = {
  async checkFeatureAccess(_, key) {
    const res = await SystemPrivate.checkFeatureAccess({key})
    return res.data || false
  },
  async checkAddingQuestionsByMatrix({commit}) {
    const res = await SystemPrivate.checkFeatureAccess({key: 'create-questions-by-matrix'})
    commit('setCanAddQuestionByMatrix', res.data || false)
  },
  async checkAddingQuestionsFromBank({commit}) {
    const res = await SystemPrivate.checkFeatureAccess({key: 'create-questions-from-bank'})
    commit('setCanAddQuestionFromBank', res.data || false)
  },
  async checkAllowCrossVendorInvoke({commit}) {
    const res = await SystemPrivate.checkFeatureAccess({key: 'allow-cross-vendor-invoke'})
    commit('setAllowCrossVendorInvoke', res.data || false)
  },
  async checkAddingQuestionsFromQS({commit}) {
    const res = await SystemPrivate.checkFeatureAccess({key: 'create-questions-from-qs'})
    commit('setCanAddQuestionFromQS', res.data || false)
  },
}
const mutations = {
  setCanAddQuestionByMatrix(state, check = false) {
    state.canAddQuestionByMatrix = check
  },
  setCanAddQuestionFromBank(state, check = false) {
    state.canAddQuestionFromBank = check
  },
  setAllowCrossVendorInvoke(state, check = false) {
    state.allowCrossVendorInvoke = check
  },
  setCanAddQuestionFromQS(state, check = false) {
    state.canAddQuestionFromQS = check
  },
}
const getters = {
  canAddQuestionByMatrix: state => state.canAddQuestionByMatrix,
  canAddQuestionFromBank: state => state.canAddQuestionFromBank,
  allowCrossVendorInvoke: state => state.allowCrossVendorInvoke,
  canAddQuestionFromQS: state => state.canAddQuestionFromQS,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
